import { useIntl } from "react-intl";

const ProjectArchiving = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.ProjectArchiving.title",
            defaultMessage: "Project archiving"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.ProjectArchiving.body",
            defaultMessage:
                "Archive projects and their associated issues when they’re no longer active to keep projects tidy, helping ensure everyone on your team has the most updated information."
        }),
        altText: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.ProjectArchiving.altText",
            defaultMessage: "Example of project archiving"
        }),
        imgCaption: intl.formatMessage({
            id: "JiraSoftwarePricingPage.modalContents.ProjectArchiving.imgCaption",
            defaultMessage: "Here’s what archived projects looks like in Jira."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-project-archiving.1353.webp"
                alt={messages.altText}
                height={560}
                loading="lazy"
            />
            <p>{messages.imgCaption}</p>
        </div>
    );
};

export default ProjectArchiving;
